import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { combineLatest, Observable } from 'rxjs';
import { CourseService } from '../../_services/course.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-course-landing-page',
  templateUrl: './course-landing-page.component.html',
  styleUrls: ['./course-landing-page.component.less']
})
export class CourseLandingPageComponent implements OnInit {

  public courseId = "5fa2046685f26526d5e9a76a";
  public isEnrolled = false;
  public hasProgress = false;
  public courseUrl: string = "";
  public course$: Observable<any>;
  public enrolledCourses$: Observable<any>;
  public loadProgress$: Observable<any>;

  constructor(private http: HttpClient, private courseService: CourseService) { 

    this.enrolledCourses$ = this.http.get<Array<any>>(`${environment.apiUrl}/api/course/courses/enrolled`, {});
    this.course$ = this.http.get<any>(`${environment.apiUrl}/api/course/${this.courseId}`);
    this.loadProgress$ = this.courseService.loadProgress(this.courseId);            
  }

  ngOnInit(): void {
    
    const combined = combineLatest([
      this.course$, 
      this.enrolledCourses$,
      this.loadProgress$]);

      combined.subscribe(([course, enrolledCourses, loadProgress]) => {

        console.log("enrolledCourses", { data: enrolledCourses })

        this.isEnrolled = enrolledCourses.filter(o => o.courseId === this.courseId).length > 0;

        this.courseUrl = `latin-america-spanish-course`;
      });
  }

  enroll(courseId) {    
    console.log('clicked');
    this.courseService.enroll(courseId);
    this.isEnrolled = true;
  }  
}
